module.exports = __webpack_public_path__ + "img/animals_03_H.77f7ad15.webp";